import { NodeExtension } from '../../../core/index.js';
import 'prosemirror-model';
import { v4 } from 'uuid';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var setParagraph = function(type) {
    return function() {
        return function(state, dispatch) {
            var tr = state.tr, selection = state.selection, schema = state.schema;
            var paragraph = schema.nodes.paragraph;
            // 处于 CellSelection 时可能有多个 range
            selection.ranges.forEach(function(range) {
                var from = range.$from.pos;
                var to = range.$to.pos;
                tr.doc.nodesBetween(from, to, function(node, pos, parent) {
                    if (node.type.name === "heading") {
                        tr.setNodeMarkup(pos, paragraph, _objectSpread({}, node.attrs));
                    }
                    if ((parent.type.name === "list_item" || parent.type === "task_item") && tr.doc.nodeAt(pos - 1)) {
                        tr.setNodeMarkup(pos - 1, null, _objectSpreadProps(_objectSpread({}, parent.attrs), {
                            level: 0
                        }));
                    }
                });
            });
            var transaction = tr;
            dispatch(transaction.scrollIntoView());
        };
    };
};

var convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ParagraphExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits(ParagraphExtension, NodeExtension);
    var _super = _createSuper(ParagraphExtension);
    function ParagraphExtension() {
        _classCallCheck(this, ParagraphExtension);
        return _super.apply(this, arguments);
    }
    var _proto = ParagraphExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            setParagraph: setParagraph()
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-0": convertCommand(setParagraph()())
        };
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        var createDom = document.createElement("div");
        createDom.innerHTML = html;
        var list = createDom.querySelectorAll("[data-diff-id]");
        list.forEach(function(h) {
            h.setAttribute("data-diff-id", "ct-diff-id-".concat(v4()));
        });
        return createDom.innerHTML;
    };
    _createClass(ParagraphExtension, [
        {
            key: "name",
            get: function get() {
                return "paragraph";
            }
        }
    ]);
    return ParagraphExtension;
}(NodeExtension);

export { ParagraphExtension };
//# sourceMappingURL=index.js.map
